import { takeLatest, put, call, select } from 'redux-saga/effects';
import { get, map } from 'lodash';
import { getFestivalsProductionsAction, getFestivalsWithProductionsAction } from './actions';
import { getListSaga } from '../App/saga';
import { selectListData } from '../../store/selectors';
import { selectFestivalsDomain } from './selectors';
import { initialState } from './reducer';
import { dateSendFormat } from '../../utils/common';
import { getProductions } from '../../utils/API';

export function* getFestivalsWithProductionsSaga({ payload, serverCookies }) {
  yield call(getListSaga, { payload, serverCookies });
  const festivals = yield select(selectListData(selectFestivalsDomain, initialState.festivals.listName));
  const ids = map(festivals, festival => get(festival, 'id'));

  const productionsPayload = yield call(
    getProductions,
    {
      limit: 10,
      date_from: dateSendFormat(),
      festival_id: ids.join(','),
    },
    {},
    serverCookies,
  );
  try {
    yield put(getFestivalsProductionsAction.success(get(productionsPayload, 'data')));
  } catch (err) {
    yield put(getFestivalsProductionsAction.failure(err.message));
  } finally {
    yield put(getFestivalsProductionsAction.fulfill());
  }
}

export default function* festivalsSaga() {
  yield takeLatest(getFestivalsWithProductionsAction.TRIGGER, getFestivalsWithProductionsSaga);
}
